export default "__VITE_ASSET__ZVhBP2CO__"